module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "template template--basic error-page"
  }, [_c('h1', [_vm._v("Oeps, pagina niet gevonden!")]), _c('p', [_vm._v("Ga terug naar "), _c('router-link', {
    attrs: {
      "to": {
        name: 'root'
      }
    }
  }, [_vm._v("de startpagina")]), _vm._v(" en probeer het opnieuw.")], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a58d6a0","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/NotFound.vue
// module id = 2INl
// module chunks = 0 1